jQuery(document).ready(function($) {
    $('a.size_guide').click(function(event) {
        event.preventDefault();
        var $el = $(this),
            $wrapper = $('.woocommerce-tabs,.wc-tabs-wrapper'),
            $tabs = $wrapper.find('.wc-tabs, ul.tabs'),
            $panels = $wrapper.find('.panels'),
            $target = $wrapper.find($el.attr('href'));

        $tabs.find('li').removeClass('active');
        $panels.find('.panel').show();
        $panels.fadeIn();
        $target.addClass('open');
        $(document.body).addClass('offcanvas-opened');
    });
});